<template>
  <work-order-card v-if="showMoreInfoCard">
    <h3 slot="card-header">更多信息</h3>
    <div slot="card-body" class="work-order-more-info-body">
      <el-form :label-width="labelWidth" :model="workOrder">
        <el-form-item
          label="相关机构："
          v-if="isIndexCompanyInfo"
          class="no-wrap"
        >
          <template v-if="showPro">
            {{ workOrder.companyInfo && workOrder.companyInfo.companyInfo }}
            <el-button
              type="text"
              class="text-btn"
              @click="
                () => {
                  showPro = false;
                  formCompanyInfo = workOrder.companyInfo.companyInfo;
                }
              "
              icon="el-icon-edit"
            >
              编辑
            </el-button>
          </template>
          <div v-else>
            <el-input
              v-model="formCompanyInfo"
              style="width: 400px"
              maxlength="100"
              show-word-limit
            ></el-input>
            <el-button type="text" class="text-btn" @click="handerSure()">
              确定
            </el-button>
            <el-button
              type="text"
              class="text-btn"
              @click="
                () => {
                  workOrder.companyInfo.companyInfo = workOrder.tempCompanyInfo;
                  showPro = true;
                }
              "
            >
              取消
            </el-button>
          </div>
        </el-form-item>
        <el-form-item label="涉及金额：" v-if="isIndexMoney" class="no-wrap">
          <template v-if="showPrice">
            {{ workOrder.money }}
            <el-button
              type="text"
              class="text-btn"
              @click="
                () => {
                  showPrice = false;
                  formTempMoney = workOrder.tempMoney;
                }
              "
              icon="el-icon-edit"
            >
              编辑
            </el-button>
          </template>
          <div v-else>
            <el-input-number
              v-model.trim="formTempMoney"
              :max="999999999"
              :precision="2"
              controls-position="right"
            ></el-input-number>
            <el-button type="text" class="text-btn" @click="handerPriceSure(1)">
              确定
            </el-button>
            <el-button
              type="text"
              class="text-btn"
              @click="
                () => {
                  workOrder.money = workOrder.tempMoney;
                  showPrice = true;
                }
              "
            >
              取消
            </el-button>
          </div>
        </el-form-item>
        <el-form-item label="优先级：">
          <span :style="{ color: colors[workOrder.priority] }">{{
            priorityEnum[workOrder.priority]
          }}</span>
          <span
            v-if="workOrder.priorityTime && workOrder.priorityTime.isTimeOut"
          >
            (处理时限:{{
              workOrder.priorityTime && workOrder.priorityTime.time
            }}小时
            <i
              :style="{
                color: workOrder.priorityTime.isTimeOut ? '#ff0000' : '',
              }"
              >已超时!</i
            >)
          </span>
        </el-form-item>
        <el-form-item label="工单来源：">
          {{ sourceChannelEnum[workOrder.sourceChannel] }}
        </el-form-item>

        <el-form-item
          label="关联工单："
          v-if="workOrder.relationWorkOrderIds"
          class="no-wrap"
        >
          <div v-for="id in workOrder.relationWorkOrderIds" :key="id">
            <router-link
              :to="{
                name: 'workmange.workOrderList.relationdetail',
                query: { wkOrderId: id },
              }"
              target="_blank"
              class="text-link"
            >
              <i class="el-icon-link"></i> {{ id }}
            </router-link>
            <el-popconfirm
              v-if="id != ''"
              title="确定删除该关联工单吗？"
              @confirm="deleteRelationId(id)"
            >
              <el-button
                slot="reference"
                type="text"
                icon="el-icon-remove-outline"
                >删除</el-button
              >
            </el-popconfirm>
          </div>
          <div v-if="isShowAddRelationId">
            <el-select
              v-model="relationId"
              placeholder="请输入工单编号"
              filterable
              remote
              clearable
              :remote-method="remoteMethod"
              style="margin-top: 10px; width: 200px"
            >
              <el-option
                v-for="item in relationWorkOrderOptions"
                :key="item.wkOrderId"
                :value="item.wkOrderId"
                :label="item.wkOrderId"
              >
                <span style="float: left">{{ item.wkOrderId }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{
                  item.wkOrderTopic
                }}</span>
              </el-option>
            </el-select>
            <el-button
              type="text"
              style="margin-left: 20px"
              @click="saveRelationId"
              icon="el-icon-finished"
              >保存</el-button
            >
            <el-button
              type="text"
              @click="deleteAddRelationId"
              icon="el-icon-remove-outline"
              >删除</el-button
            >
          </div>
          <el-button
            type="text"
            @click="addRelationId"
            icon="el-icon-circle-plus-outline"
            >新增</el-button
          >
        </el-form-item>
        <el-form-item label="标签信息：" v-if="workOrder.labelName">
          {{
            workOrder.labelName &&
            workOrder.labelName.map((item) => item.labelName).join(",")
          }}
        </el-form-item>
        <el-form-item
          label="网址信息："
          v-if="workOrder.websiteDto"
          class="no-wrap"
        >
          <el-card style="margin-bottom: 10px">
            <div style="display: flex">
              <span>网址：</span>
              <span class="show-text">{{
                workOrder.websiteDto.websiteUrl
              }}</span>
              <el-button
                type="text"
                @click="copy(workOrder.websiteDto.websiteUrl)"
                >复制</el-button
              >
            </div>
            <div style="display: flex">
              <span>网站名称：</span>
              <span
                class="show-text"
                @click="copy(workOrder.websiteDto.websiteName)"
                >{{ workOrder.websiteDto.websiteName }}</span
              >
              <el-button
                type="text"
                @click="copy(workOrder.websiteDto.websiteName)"
                >复制</el-button
              >
            </div>
          </el-card>
        </el-form-item>
        <el-form-item
          label="医生信息："
          v-if="workOrder.doctorInfo"
          class="no-wrap"
        >
          <el-card style="margin-bottom: 10px; width: 80%">
            <el-form label-width="120px">
              <div style="display: flex">
                <span>医生姓名：</span>
                <span v-if="showDoctorName" class="show-text">
                  {{ workOrder.doctorInfo.doctorName }}
                  <el-button
                    v-if="workOrder.status !== 1 && workOrder.status !== 2"
                    type="text"
                    class="text-btn"
                    @click="
                      () => {
                        showDoctorName = false;
                        formDoctorInfo.doctorName =
                          workOrder.doctorInfo.doctorName;
                      }
                    "
                    icon="el-icon-edit"
                  >
                    编辑
                  </el-button>
                </span>
                <div v-else>
                  <el-input
                    v-model="formDoctorInfo.doctorName"
                    style="width: 200px"
                    maxlength="20"
                  ></el-input>
                  <el-button
                    type="text"
                    class="text-btn"
                    @click="() => handerDoctorSure('name')"
                  >
                    确定
                  </el-button>
                  <el-button
                    type="text"
                    class="text-btn"
                    @click="
                      () => {
                        formDoctorInfo.doctorName =
                          workOrder.doctorInfo.doctorName;
                        showDoctorName = true;
                      }
                    "
                  >
                    取消
                  </el-button>
                </div>
              </div>
              <div style="display: flex">
                <span>医生执业资格证：</span>
                <span v-if="showDoctorPc" class="show-text">
                  {{ workOrder.doctorInfo.practiceCertificate }}
                  <el-button
                    v-if="workOrder.status !== 1 && workOrder.status !== 2"
                    type="text"
                    class="text-btn"
                    @click="
                      () => {
                        showDoctorPc = false;
                        formDoctorInfo.practiceCertificate =
                          workOrder.doctorInfo.practiceCertificate;
                      }
                    "
                    icon="el-icon-edit"
                  >
                    编辑
                  </el-button>
                </span>
                <div v-else>
                  <el-input
                    v-model="formDoctorInfo.practiceCertificate"
                    style="width: 200px"
                    maxlength="100"
                  ></el-input>
                  <el-button
                    type="text"
                    class="text-btn"
                    @click="
                      () => {
                        workOrder.doctorInfo.practiceCertificate =
                          formDoctorInfo.practiceCertificate;
                        showDoctorPc = true;
                      }
                    "
                  >
                    确定
                  </el-button>
                  <el-button
                    type="text"
                    class="text-btn"
                    @click="
                      () => {
                        formDoctorInfo.practiceCertificate =
                          workOrder.doctorInfo.practiceCertificate;
                        showDoctorPc = true;
                      }
                    "
                  >
                    取消
                  </el-button>
                </div>
              </div>
            </el-form>
          </el-card>
        </el-form-item>

        <!-- v4.0 -->
        <el-form-item label="地区信息：" v-if="workOrder.regional">
          {{ convertAreaId2Name() }}
        </el-form-item>
        <el-form-item
          label="关联项目信息："
          v-if="accurateProjectNames || showAccurateProjectEdit"
        >
          <template v-if="!showAccurateProjectEdit">
            {{ accurateProjectNames }}
            <el-button
              type="text"
              class="text-btn"
              icon="el-icon-edit"
              @click="startAccurateProjectEdit"
            >
              编辑
            </el-button>
          </template>
          <div v-else class="accurate-project-editor">
            <el-select
              v-model="formAccurateProjectInfo"
              placeholder="请选择关联项目信息"
              :disabled="projectLoading || projectSaving"
              filterable
              clearable
            >
              <el-option
                v-for="project in projectTree"
                :key="project.id"
                :label="project.name"
                :value="project.id"
                :disabled="project.disabled"
              >
                <span>{{ project.name }}</span>
                <span
                  class="project-status"
                  :class="project.disabled ? 'is-disabled' : 'is-enabled'"
                >
                  {{ project.disabled ? "禁用" : "启用" }}
                </span>
              </el-option>
            </el-select>
            <el-button
              type="text"
              class="text-btn"
              :loading="projectSaving"
              @click="saveAccurateProjectInfo"
            >
              确定
            </el-button>
            <el-button
              type="text"
              class="text-btn"
              :disabled="projectSaving"
              @click="cancelAccurateProjectEdit"
            >
              取消
            </el-button>
          </div>
        </el-form-item>
        <el-form-item label="业务类型：" v-if="workOrder.businessType">
          {{ convertBusinessType(workOrder.businessType) }}
        </el-form-item>
        <el-form-item
          label="客户信息："
          v-if="workOrder.accurateCustomerInfo"
          class="no-wrap"
        >
          <div>用户ID：{{ workOrder.accurateCustomerInfo.customerId }}</div>
          <div>手机号：{{ workOrder.accurateCustomerInfo.customerPhone }}</div>
        </el-form-item>
        <el-form-item
          label="机构信息："
          v-if="workOrder.accurateCompanyInfo"
          class="no-wrap"
        >
          <p>机构ID：{{ workOrder.accurateCompanyInfo.companyId }}</p>
          <p>机构名称：{{ workOrder.accurateCompanyInfo.companyName }}</p>
          <p>机构简称：{{ workOrder.accurateCompanyInfo.abbreviation }}</p>
        </el-form-item>
      </el-form>
    </div>
  </work-order-card>
</template>

<script>
import api from "plus/api";
import { throttle } from "lodash";
export default {
  name: "workOrderMoreInfo",
  props: {
    workOrder: {
      type: Object,
      default: () => {},
    },
    /** 为 true 时不按 handlerType 过滤，始终展示更多信息（如质检详情页） */
    alwaysShowMoreInfo: {
      type: Boolean,
      default: false,
    },
    labelWidth: {
      type: String,
      default: "100px",
    },
  },
  watch: {
    workOrder: {
      handler: function (val) {
        //判断是否包含 相关机构和涉及金额
        this.isIndexMoney = false;
        this.isIndexCompanyInfo = false;
        if (val.templates && val.templates.length) {
          val.templates.map((item) => {
            if (item.moduleName.indexOf("COMPANY_MODEL") != -1) {
              this.isIndexCompanyInfo = true;
            }
            if (item.moduleName.indexOf("MONEY_MODEL") != -1) {
              this.isIndexMoney = true;
            }
          });
        }
        val.tempMoney = val.money;
        this.formTempMoney = val.money;
        if (!val.companyInfo) {
          val.companyInfo = { companyInfo: "" };
        }
        val.tempCompanyInfo = val.companyInfo
          ? val.companyInfo.companyInfo
          : "";
        this.formCompanyInfo = val.companyInfo
          ? val.companyInfo.companyInfo
          : "";
        this.formDoctorInfo = val.doctorInfo ? { ...val.doctorInfo } : "";
        this.formAccurateProjectInfo = this.getAccurateProjectIds(val)[0] || "";
        this.showPrice = true; // 涉及金额
        this.showPro = true; // 相关机构
        this.showDoctorName = true; // 医生信息-姓名
        this.showDoctorPc = true; // 医生信息-执业资格证
        this.showAccurateProjectEdit = false;
      },
      deep: true,
      immediate: true,
    },
    $route(_to, _from) {
      this.relationId = "";
      this.isShowAddRelationId = false;
    },
  },
  data() {
    return {
      isIndexMoney: false,
      isIndexCompanyInfo: false,
      showPrice: true, // 涉及金额
      showPro: true, // 相关机构
      showDoctorName: true, // 医生信息-姓名
      showDoctorPc: true, // 医生信息-执业资格证
      formCompanyInfo: "",
      formTempMoney: "",
      formDoctorInfo: {
        doctorName: "",
        practiceCertificate: "",
      },
      dialog: false,
      priorityEnum: {
        0: "一般",
        1: "重要",
        2: "严重",
      },
      colors: {
        0: "black",
        1: "orange",
        2: "red",
      },
      sourceChannelEnum: {
        IM: "呗呗表单",
        PAGE_SUBMISSION: "页面填写",
        MBT: "美呗通客户端",
        FENDAN_WAREHOUSE: "智能分单",
        YXGL: "营销管理系统",
      },
      // 关联工单
      relationWorkOrderOptions: [],
      isShowAddRelationId: false,
      relationId: "",
      // v4.0
      areaTree: [],
      showAccurateProjectEdit: false,
      formAccurateProjectInfo: "",
      projectTree: [],
      projectLoading: false,
      projectSaving: false,
    };
  },
  methods: {
    getAccurateProjectIds(workOrder = this.workOrder) {
      if (!workOrder || !Array.isArray(workOrder.accurateProjectInfo)) {
        return [];
      }
      return workOrder.accurateProjectInfo
        .map((item) => item && item.projectId)
        .filter(Boolean);
    },
    async startAccurateProjectEdit() {
      this.formAccurateProjectInfo = this.getAccurateProjectIds()[0] || "";
      this.showAccurateProjectEdit = true;
      await this.getProjectTree();
    },
    cancelAccurateProjectEdit() {
      this.formAccurateProjectInfo = this.getAccurateProjectIds()[0] || "";
      this.showAccurateProjectEdit = false;
    },
    async saveAccurateProjectInfo() {
      this.projectSaving = true;
      try {
        const response = await api.work.editAccurateProjectInfo({
          workOrderId: this.workOrder.wkOrderId,
          accurateProjectInfo: this.formAccurateProjectInfo
            ? [this.formAccurateProjectInfo]
            : [],
        });
        if (response.data.code === 0) {
          this.$message.success("修改成功");
          this.showAccurateProjectEdit = false;
          this.$emit("refresh");
          return;
        }
        this.$message.error(response.data.msg || "修改失败");
      } finally {
        this.projectSaving = false;
      }
    },
    async getProjectTree() {
      if (this.projectLoading || this.projectTree.length > 0) return;
      this.projectLoading = true;
      try {
        const response = await api.common.getProjectTree();
        this.projectTree = this.formatProjectTree(response.data.data || []);
      } finally {
        this.projectLoading = false;
      }
    },
    formatProjectTree(list) {
      return list.map((item) => {
        const disabled = item.isEnable === false;
        const childs = Array.isArray(item.childs)
          ? this.formatProjectTree(item.childs)
          : [];
        const project = {
          ...item,
          disabled,
          displayName: `${item.name}（${disabled ? "禁用" : "启用"}）`,
        };
        if (childs.length > 0) {
          project.childs = childs;
        } else {
          delete project.childs;
        }
        return project;
      });
    },
    // 相关机构
    async handerSure() {
      const response = await api.work.editCompanyInfo({
        workOrderId: this.workOrder.wkOrderId,
        companyInfoDto: { companyInfo: this.formCompanyInfo },
      });
      if (response.data.code == 0)
        this.workOrder.tempCompanyInfo = this.formCompanyInfo;
      this.showPro = true;
      this.$emit("refresh");
    },
    // 涉及金额
    async handerPriceSure() {
      const response = await api.work.editMoney({
        workOrderId: this.workOrder.wkOrderId,
        money: this.formTempMoney,
      });
      if (response.data.code == 0)
        this.workOrder.tempMoney = this.formTempMoney;
      this.showPrice = true;
      this.$emit("refresh");
    },
    // 医生信息
    async handerDoctorSure(type) {
      const response = await api.work.editDoctorInfo({
        workOrderId: this.workOrder.wkOrderId,
        doctorInfo: this.formDoctorInfo,
      });
      // if (response.data.code == 0)
      //     this.workOrder.doctorInfo = { ...this.formDoctorInfo }
      if (type === "pc") {
        this.showDoctorPc = true;
      } else if (type === "name") {
        this.showDoctorName = true;
      }

      this.$emit("refresh");
    },
    copy(str) {
      const el = document.createElement("textarea");
      el.value = str;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      const selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
      this.$message.success("复制成功");
    },
    // 关联工单
    addRelationId() {
      if (this.isShowAddRelationId) {
        this.$message.warning("请先保存再新增");
      }
      this.isShowAddRelationId = true;
    },
    deleteAddRelationId() {
      this.isShowAddRelationId = false;
      this.relationId = "";
    },
    checkIsNum(str) {
      return /^\d+$/.test(str);
    },
    remoteMethod: throttle(function (query) {
      if (!this.checkIsNum(query)) {
        // this.$message.warning('工单编号必须为数字')
        return;
      }
      if (query) {
        this.getRelationWorkOrder({
          wkOrderId: query,
        });
      } else {
        this.relationWorkOrderOptions = [];
      }
    }, 500),
    async getRelationWorkOrder(filters) {
      const response = await api.work.getRelationWorkOrder(filters);
      this.relationWorkOrderOptions = response.data.data;
    },
    async saveRelationId() {
      if (!this.relationId) {
        this.$message.warning("请选择关联工单");
        return;
      }
      const res = await api.work.addWorkRelationId({
        relationWorkOrderId: this.relationId,
        wkOrderId: this.workOrder.wkOrderId,
      });
      if (res.data.code == 0) {
        this.$message.success("关联成功");
        this.getRelationIds();
        this.deleteAddRelationId();
      } else {
        this.$message.error(res.data.msg);
      }
    },
    async deleteRelationId(id) {
      const res = await api.work.deleteWorkRelationId({
        relationWorkOrderId: id,
        wkOrderId: this.workOrder.wkOrderId,
      });
      if (res.data.code == 0) {
        this.$message.success("操作成功");
        this.getRelationIds();
      } else {
        this.$message.error(res.data.msg);
      }
    },
    async getRelationIds() {
      const res = await api.work.getWorkRelationIds(this.workOrder.wkOrderId);
      if (res.data.code == 0) {
        this.workOrder.relationWorkOrderIds = res.data.data;
      }
    },
    // v4.0
    getNodeKey(node) {
      return node?.areaId || node?.id;
    },
    findNodePath(tree, targetId, path = []) {
      if (!Array.isArray(tree) || !targetId) return null;
      for (let node of tree) {
        const currentPath = [...path, node];
        if (this.getNodeKey(node) === targetId) {
          return currentPath;
        }
        if (node.children && node.children.length > 0) {
          const found = this.findNodePath(node.children, targetId, currentPath);
          if (found) return found;
        }
      }
      return null;
    },
    async getAreaTree() {
      const response = await api.common.getAreaTree();
      const fullTree = response.data.data;
      this.areaTree = fullTree;
    },
    convertAreaId2Name() {
      if (!this.workOrder.regional.city) return "";
      const path = this.findNodePath(
        this.areaTree,
        this.workOrder.regional.city,
      );
      return `${path[0].areaName} ${path[1].areaName} ${path[2].areaName}`;
    },
    convertBusinessType(businessType) {
      if (businessType == "REFERRAL") return "转诊";
      if (businessType == "HAIR_TRANSPLANT") return "植发";
      if (businessType == "ORAL_CAVITY") return "口腔";
    },
  },
  created() {
    this.getAreaTree();
  },
  computed: {
    accurateProjectNames() {
      if (
        !this.workOrder ||
        !Array.isArray(this.workOrder.accurateProjectInfo)
      ) {
        return "";
      }
      return this.workOrder.accurateProjectInfo
        .map((item) => item && item.projectName)
        .filter(Boolean)
        .join("、");
    },
    showMoreInfoCard() {
      if (this.alwaysShowMoreInfo) {
        return true;
      }
      if (this.accurateProjectNames) {
        return true;
      }
      return this.workOrder && this.workOrder.handlerType === "NORMAL";
    },
  },
};
</script>

<style lang="less" scoped>
.el-form-item {
  margin-bottom: 0px !important;
}
.text-link {
  color: #409eff;
  text-decoration: underline;
  margin-right: 10px;
}
.text-link:hover {
  color: #66b1ff;
}
.show-text {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.text-btn {
  margin-left: 10px;
  padding: 0;
}
.accurate-project-editor {
  display: flex;
  align-items: center;

  .el-select {
    width: 400px;
  }
}
.project-status {
  display: inline-block;
  margin-left: 8px;
  padding: 0 6px;
  border-radius: 8px;
  font-size: 12px;
  line-height: 18px;
  white-space: nowrap;

  &.is-enabled {
    color: #0b6b47;
    background-color: #e8f6f0;
  }

  &.is-disabled {
    color: #606266;
    background-color: #f2f3f5;
  }
}
</style>
